import { Injectable } from '@angular/core';
import { ContentfulService } from 'src/app/shared/services/contentful.service';
import { Entry } from 'contentful';
import { ContentFulModel } from 'src/app/shared/models/contentfulmodel';
import { BehaviorSubject } from 'rxjs';
import { PageId } from 'src/app/shared/utilities/pageids.enum';
@Injectable({
  providedIn: 'root',
})
export class AtlasService {
  atlasPageData: any;

  private heroSubject$ = new BehaviorSubject<any>(null);
  public hero$ = this.heroSubject$.asObservable();

  private customerStatsSubject$ = new BehaviorSubject<any>(null);
  public customerStats$ = this.customerStatsSubject$.asObservable();

  private embeddedCollectionSubject$ = new BehaviorSubject<any>(null);
  public embeddedCollection$ = this.embeddedCollectionSubject$.asObservable();

  private digitalPlatformSubject$ = new BehaviorSubject<any>(null);
  public digitalPlatform$ = this.digitalPlatformSubject$.asObservable();

  private customerStorySubject$ = new BehaviorSubject<any>(null);
  public customerStory$ = this.customerStorySubject$.asObservable();

  private faqSubject$ = new BehaviorSubject<any>(null);
  public faq$ = this.faqSubject$.asObservable();

  private newsListSubject$ = new BehaviorSubject<any>(null);
  public newsList$ = this.newsListSubject$.asObservable();

  private readyToSubject$ = new BehaviorSubject<any>(null);
  public readyTo$ = this.readyToSubject$.asObservable();

  private exporeMoreSubject$ = new BehaviorSubject<any>(null);
  public exploreMore$ = this.exporeMoreSubject$.asObservable();

  private coverageSubject$ = new BehaviorSubject<any>(null);
  public coverage$ = this.coverageSubject$.asObservable();

  private coverageCurrencySubject$ = new BehaviorSubject<any>(null);
  public coverageCurrency$ = this.coverageCurrencySubject$.asObservable();

  private valuesSubject$ = new BehaviorSubject<any>(null);
  public values$ = this.valuesSubject$.asObservable();

  private contentPanelSubject$ = new BehaviorSubject<any>(null);
  public contentPanel$ = this.contentPanelSubject$.asObservable();

  private featuresSubject$ = new BehaviorSubject<any>(null);
  public features$ = this.featuresSubject$.asObservable();

  private getStartedContentSubject$ = new BehaviorSubject<any>(null);
  public getStartedContent$ = this.getStartedContentSubject$.asObservable();

  constructor(private contentful: ContentfulService) {}

  getAtlasLandingPageData() {
    this.contentful
      .getEntries(
        Object.assign({
          content_type: PageId.solutionsPage,
          include: 10,
        })
      )
      .then(res => {
        let mod = res.items as Entry<any>[];
        this.atlasPageData = mod.filter(
          x => x?.fields['id'] == PageId.atlasLandingPage
        );
        const heroData = this.atlasPageData[0].fields.psHeroPanel;
        if (heroData) {
          this.heroSubject$.next(heroData);
        }
        const customerStats =
          this.atlasPageData[0].fields.psCustomerStatsContentPanel;
        if (customerStats) {
          this.customerStatsSubject$.next(customerStats);
        }
        const embeddedCollection =
          this.atlasPageData[0].fields.psProductSuite2;
        if (embeddedCollection) {
          this.embeddedCollectionSubject$.next(embeddedCollection);
        }
        const digitalPlatform = this.atlasPageData[0].fields.psProductSuite;
        if (digitalPlatform) {
          this.digitalPlatformSubject$.next(digitalPlatform);
        }
        const customerStory = this.atlasPageData[0].fields.psCustomerStories;
        if (customerStory) {
          this.customerStorySubject$.next(customerStory);
        }
        const faq = this.atlasPageData[0].fields.psFaqPanel;
        if (faq) {
          this.faqSubject$.next(faq);
        }
        const newsList = this.atlasPageData[0].fields.psBlogPanel;
        if (newsList) {
          this.newsListSubject$.next(newsList);
        }

        const readyToPanelData =
          this.atlasPageData[0].fields.psGetStartedPanel.fields;
        if (readyToPanelData) {
          this.readyToSubject$.next(readyToPanelData);
        }

        const exploreMorePanelData =
          this.atlasPageData[0].fields.psOtherProductsPanel.fields;
        if (exploreMorePanelData) {
          this.exporeMoreSubject$.next(exploreMorePanelData);
        }

        const coverageData = this.atlasPageData[1].fields.atlasCoverage[0];
        if (coverageData) {
          this.coverageSubject$.next(coverageData);
        }

        const coverageCurrencyData =
          this.atlasPageData[1].fields.atlasCoverage[1];

        if (coverageCurrencyData) {
          this.coverageCurrencySubject$.next(coverageCurrencyData);
        }

        const atlasValues = this.atlasPageData[1].fields.atlasValues;
        if (atlasValues) {
          this.valuesSubject$.next(atlasValues);
        }
        const contentPanelsData = this.atlasPageData[1].fields.contentPanel;
        if (contentPanelsData) {
          this.contentPanelSubject$.next(contentPanelsData);
        }

        const getStartedData =
          this.atlasPageData[1].fields.getStartedContentPanel;
        if (getStartedData) {
          this.getStartedContentSubject$.next(getStartedData);
        }

        const featuresData = this.atlasPageData[1].fields.features;
        if (featuresData) {
          this.featuresSubject$.next(featuresData);
        }
      })
      .catch(errorRes => {});
  }
}
